import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useChallengeInstance = (id, enabled = true) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['challengeInstance', id],
    queryFn: async () => {
      const result = await restClient({ 
        url: `${prefix}/challenge/${id}/instance`, 
        method: 'get'
      });
      return result;
    },
    enabled: !!id && enabled,
    staleTime: 0, 
    cacheTime: 0,
    refetchOnWindowFocus: false,
  });
};